import type { ListBuilderList } from '../../../types';

/**
 * Overdue — SRs whose `targetDate` is in the past and that haven't
 * yet reached a terminal state. Mirrors `comingDueList` but reaches
 * back arbitrarily far (`{{DATE:-365d}}` start as a practical lower
 * bound for the rolling window — anything older than a year is
 * almost certainly abandoned, not "overdue").
 *
 * Sorts oldest-first so the worst offenders surface to the top.
 */
export const overdueList: ListBuilderList = {
	id: 'default-sourcing-requests-overdue',
	cacheTTL: 300000,
	name: 'Overdue',
	type: 'default',
	active: true,
	sortOrder: 3,
	defaultSortId: 'column-sr-target-date-asc',
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestStatus: {
			defaultValue: [
				{ id: 'draft', label: 'Draft' },
				{ id: 'open', label: 'Open' },
				{ id: 'in_progress', label: 'In Progress' },
				{ id: 'partially_fulfilled', label: 'Partially Fulfilled' },
			],
			locked: true,
			hidden: true,
		},
		sourcingRequestTargetDateRange: {
			defaultValue: {
				startDate: '{{DATE:-365d}}',
				endDate: '{{DATE:-1d}}',
			},
			locked: true,
			hidden: false,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
